// extracted by mini-css-extract-plugin
export default {"cls1":"StyledComponents-DismissText_cls1__j9o5M","cls2":"StyledComponents-DismissText_cls2__E-Vdq StyledComponents-DismissText_cls1__j9o5M"};